// extracted by mini-css-extract-plugin
export default {"container":"jO-z","title":"kO-z","link":"lO-z"};